import {createContext} from 'react';

const ChatbotContext = createContext(null);

export default ChatbotContext;
